var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.496277,
    y: 0.663086,
    width: 52.121,
    height: 52.121,
    fill: "url(#pattern0_67_681)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_67_681",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_67_681",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_67_681",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABCtJREFUeF7tmk2oTVEUx38vIVJERAwoogwkAxOGBkpMTAyYGMlXyUCUUkbKwFdvYqqUiTKRKcpQytDHBCPGTHC3d9V7t3Pv2Xevte7dp/c/03fW/6z1+5177n773Bl0VEVgpqpu1AwSUtlNICESUhmBytrRJ0RCKiNQWTv6hEhIZQQqa0efkEUoZAmwDzgI7AJ2AluANcAqYGmfSVdujtB5oiAkyIeBk8AhYHXGjRjVS8alW0+Z2DzeENYBF4AzwPrWMRee4N3LmJdvPH3i83hBWAlcBS72H0MlMLx6Kbn2YM3U5vGAcAS4B2w1kvDoxdjCv/KpzmOBsBy4BZwHl01KSy8eIqqYpxTCpt7K6Vl/9eQBI2WU9uJx/WrmKYGwDXgBbPcgMS+jpBePFqqaZ1wIScJLYKMHiYGMcXvxaKG6ecaBsAF4BezwINGQMU4vHi1UOU8uhPSF99r5O2MQam4vHjKqnScXwn3grAeJERm5vXi0Ue08ORDSujytqKKPnF48eqh6njYIK4D3QFqJRB9tvXhcv/p52iDcBK55kJiX8Q2YBZ73Nh8/9Pa+fjjnj4qrfp5RQtLG2mfD3tQgmD/AHeAK8GuCEv5fqhPzjBJyA7juBO43cKq3ZH7klFcS04l5hglJ+/9fCrbQh4G6DNwuoehU05l5hgk5Bjx1gpFWaEedskpjOjPPMCFPgOOl08+r+wns7j2uPjpkWSI6M0+TkPTO+Hvma9c2SA+Ac20nBf+9U/M0CdkPvHGCtBd465RVGtOpeZqEXHL6An4H7Cml6FjXqXmahDwETjsAudt/x+4QZYro1DxNQtL7jgMmBHPFJ3q/w3rskGON6NQ8TUI+OfxgIUFMj6v02Jr20al5moSkFdZaB4qbga8OOdaITs3TJCTtMy2zUgDSzmr6P2TaR6fmaRKSNgE9jradZI9r5GR0ah4JyVE6d85EbjAJkZB8Ak5n6pHlBHJYzLiPDi8hUWMtmCfykTWRATIuIiEZkCyn6BNioRdQKyEBUC2REmKhF1ArIQFQLZESYqEXUCshAVAtkRJioRdQKyEBUC2REmKhF1ArIQFQLZESYqEXUCshAVAtkRJioRdQKyEBUC2REmKhF1ArIQFQLZESYqEXUCshAVAtkRJioRdQKyEBUC2REmKhF1ArIQFQLZESYqEXUCshAVAtkRJioRdQKyEBUC2REmKhF1ArIQFQLZESYqEXUCshAVAtkRJioRdQKyEBUC2REmKhF1ArIQFQLZESYqEXUCshAVAtkRJioRdQu+iEBDBUZC6Bce+23FydV0hAQgrBRZVJSBTZwlwJKQQXVSYhUWQLcyWkEFxUmYREkS3MlZBCcFFlEhJFtjBXQgrBRZVJSBTZwlwJKQQXVSYhUWQLcyWkEFxUmYREkS3MlZBCcFFlEhJFtjD3L3gVumW0y8rfAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/Quote.454cc89159283860e02046cf7453a46f.svg";
export { ForwardRef as ReactComponent };